import React, { useEffect, useState } from "react";
import "./dashboard.css";
import { getFromLocalStorage } from "../../../utils/common-utils";
import CustomModal from "../../../components/Modal/CustomModal";
import ChangePassword from "../../../components/firstLogin/changePassword";
import { Chart as ChartJS } from "chart.js/auto";
import { Line, Doughnut, Bar } from "react-chartjs-2";
import {
  getCountryOperator,
  getDashboarFirstCardsdData,
  getMidDashboardData,
  getPieChartData,
} from "../../../api/Api";
import axios from "axios"; // or your API utility
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TopCards from "../../../components/dashboard/topCards";
import DoughutData from "../../../components/dashboard/DoughutData";
import MidCards from "../../../components/dashboard/midCards";
import BarGraph from "../../../components/dashboard/BarGraph";
import CountriesList from "../../../components/dashboard/countriesList";
const Dashboard = () => {
  const userData = getFromLocalStorage("userData");
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [dashboardData, setDashboardData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [operatorData, setOperatorData] = useState([]);
  const [midDashboardData, setMidDashboardData] = useState([]);
  const navigate = useNavigate();

  // Add loading state
  const [isFilterLoading, setIsFilterLoading] = useState(false);

  // Update the state to store pie chart data
  const [pieChartData, setPieChartData] = useState({
    serviceData: null,
    packageData: null,
  });

  // Add this function to get date from one year ago
  const getOneYearAgo = () => {
    const date = new Date();
    date.setFullYear(date.getFullYear() - 1);
    return date.toISOString().split("T")[0];
  };

  // Function to get yesterday's date in YYYY-MM-DD format
  const getYesterday = () => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return yesterday.toISOString().split("T")[0];
  };

  // Function to get today's date in YYYY-MM-DD format
  const getToday = () => {
    return new Date().toISOString().split("T")[0];
  };

  // Initialize filters with yesterday's date as start date
  const [filters, setFilters] = useState({
    countryCode: "All",
    operatorCode: "All",
    startDate: getYesterday(),
    endDate: getToday(),
  });

  // Function to fetch mid dashboard data
  const fetchMidDashboardData = async (filterParams) => {
    try {
      setIsFilterLoading(true); // Start loading
      const payload = {
        countryCode: filterParams.countryCode,
        operatorCode: filterParams.operatorCode,
        startDate: filterParams.startDate,
        endDate: filterParams.endDate,
      };

      const response = await getMidDashboardData(payload);
      if (response?.statusDescription?.status === 200) {
        setMidDashboardData(response?.dashboard);
      } else {
        console.error(
          "Error fetching dashboard data:",
          response?.statusDescription?.message
        );
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setIsFilterLoading(false); // Stop loading
    }
  };
  console.log("midDashboardData", midDashboardData);
  const fetchCountryOperatorData = async () => {
    try {
      const response = await getCountryOperator();
      if (response?.statusDescription?.status === 200) {
        setCountryData(response?.countryListResponse);
        setOperatorData(response?.operatorList);
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };

  useEffect(() => {
    if (userData?.firstLogin === false) {
      setShowPasswordModal(true);
    }
  }, []);

  return (
    <div className="content-wrapper dashboard">
      {/* Welcome Banner */}
      <div className="welcome-banner">
        <h1>Welcome, {userData?.firstName}!</h1>
        <p className="m-0">Altruist CMS Dashboard Overview</p>
      </div>

      {userData?.userGroups == 6 ? (
        ""
      ) : (
        <>
          <TopCards />

          {/* Stats Cards */}

          <MidCards />

          {/* Mid Dashboard Stats Section */}
          <DoughutData />

          {/* Charts Section */}
          <BarGraph />

          {/* Recent Activity */}
          {/* <CountriesList /> */}

          {/* Change Password Modal */}
          <CustomModal
            show={showPasswordModal}
            onHide={() => {
              if (userData?.firstLogin !== false) {
                setShowPasswordModal(false);
              }
            }}
            title="Change Password Required"
            size="lg"
            dialogClassName="custom-modal-class"
            backdrop="static"
            keyboard={false}
            closeButton={false}
          >
            <ChangePassword
              onClose={() => setShowPasswordModal(false)}
              isFirstLogin={userData?.firstLogin === false}
            />
          </CustomModal>
        </>
      )}
    </div>
  );
};

export default Dashboard;
